import AsertoNameValidator from './AsertoNameValidator'

const AccountNameValidator = AsertoNameValidator

export default AccountNameValidator
